import * as ng from 'angular';
import { CodiceDestinatarioService } from '../../../../../services/codice-destinatario.service';

class RequestCodiceDestinatarioFatturaPRController implements ng.IController {

    static $inject: string[] = [
        '$scope',
        '$rootScope',
        '$state',
        'store',
        '$uibModal',
        'CodiceDestinatarioService',
        '$q'
    ];

    constructor(
        private $scope: any,
        private $rootScope: any,
        private $state: ng.ui.IStateService,
        private store: ng.a0.storage.IStoreService,
        private $uibModal: ng.ui.bootstrap.IModalService,
        private _codiceDestinatarioService: CodiceDestinatarioService,
        private $q: any
    ) {
        _codiceDestinatarioService.getCodiceDestinatario().then((result: any) => {
            if (result.exists) {
                $scope.codiceDestinatario = result.codiceDestinatarioDocument;
                if ($scope.codiceDestinatario.code && $scope.codiceDestinatario.code.length > 0 && $scope.codiceDestinatario.code.substring(0, 1) === '*') {
                    $scope.codiceDestinatario.code = 'ACTKBBZ';
                }
                _codiceDestinatarioService.impostaCodiceDestinatario(result.codiceDestinatarioDocument);
                $scope.disableAssignCodiceDestinatarioButton = true;
            }
        }, (error) => {
            this.$q.reject(error);
        });
        $scope.pageHeader = 'Codice Destinatario';
        $scope.user = store.get('user');
        $scope.disableAssignCodiceDestinatarioButton = false;

        $scope.codiceDestinatario = {
            code: 'ACTKBBZ'
        };

        // <editor-fold desc='openEnableFatturaPrivatiModal'>
        $scope.openEnableFatturaPrivatiModal = (size) => {

            let FatturazioneConfermaModal = $uibModal.open({
                animation: true,
                component: 'enableFatturaPRModalComponent',
                size: size,
                windowClass: 'center-modal',
                backdrop: 'static',
                keyboard: false
            });
        };
        // </editor-fold>
    }
}

export const RequestCodiceDestinatarioFatturaPRComponent: ng.IComponentOptions = {
    template: require('./request-codice-destinatario-fattura-pr.html'),
    controller: RequestCodiceDestinatarioFatturaPRController
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/fatturazione/fatturazione-pr/request-codice-destinatario-fattura-pr/request-codice-destinatario-fattura-pr.ts